import React from 'react'

const SettingTenantContainer = () => {
    return (
        <section className="LeadContainer">
        </section>
    )
}

export default SettingTenantContainer